$(document).ready(function () {
    'use strict';

    $('.js_pageTabLink.active').on('click', function (e) {
        var page_tab_links = $('.pageTabLinks');

        if (matchesMediaQuery(0, 850)) {
            e.preventDefault();

            if (page_tab_links.height() < 100) {
                page_tab_links.animate({
                    height: '200px'
                });
            } else {
                page_tab_links.animate({
                    height: '37px'
                });
            }
        }
    });
});